import type { ManualOverrideReleasePolicy } from '@/services/inventory'

function toValidDateOrNull(value: unknown): Date | null {
  if (value == null) return null
  const d = new Date(value as string)
  return Number.isNaN(d.getTime()) ? null : d
}

function formatPolicyExpiryDate(value: unknown): string {
  const raw = String(value ?? '').trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split('-').map(Number)
    const d = new Date(year, month - 1, day)
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(d)
  }

  const d = toValidDateOrNull(value)
  if (!d) return 'a specific date'

  const hasLocalTime = d.getHours() !== 0 || d.getMinutes() !== 0 || d.getSeconds() !== 0

  if (hasLocalTime) {
    const datePart = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(d)
    const timePart = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(d)
    return `${datePart} at ${timePart}`
  }

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(d)
}

/** Compact locked-override policy summary for the field row. */
export function formatLockedOverridePolicySummary(
  policy: ManualOverrideReleasePolicy,
  expiresAt?: string,
): string {
  switch (policy) {
    case 'UNTIL_SOLD':
      return 'Locked until sold'
    case 'UNTIL_DATE':
      return `Locked until ${formatPolicyExpiryDate(expiresAt)}`
    case 'MANUAL_RELEASE_ONLY':
      return 'Locked until manually released'
    case 'UNTIL_FEED_VALUE_CHANGES':
    default:
      return 'Locked until feed value changes'
  }
}
